import { Role } from "../domain/enums/RoleEnum";
import { UserDTO } from "../domain/models/dto/UserDTO";
import { User } from "../domain/models/User";
import { BaseModelImpl } from "./BaseModelImpl";

export default class UserModel extends BaseModelImpl<UserDTO> implements User {
    firstName: string = "";
    lastName: string = "";
    middleName: string;
    email: string;
    phone?: string;
    roleId: Role;

    get fullName(): string {
        return `${this.firstName} ${this.lastName}`.trim();
    }

    get isSuperAdmin(): boolean {
        return this.roleId === Role.SUPER_ADMIN;
    }

    constructor(data?: UserDTO) {
        super();
        this.assignData(data);
    }
}
